export default __webpack_public_path__ + "2c0d0f4104f8627d613fd5077bfdc9f0.svg";